import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var TabSelect = function TabSelect(_ref) {
  var tabs = _ref.tabs,
      selectedTab = _ref.selectedTab,
      onSelect = _ref.onSelect,
      children = _ref.children;

  var onSelectTabHandler = function onSelectTabHandler(tab) {
    if (onSelect instanceof Function) {
      onSelect(tab);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "w-max mt-6 overflow-auto no-scrollbar border border-2 rounded border-subkit-primary bc-gray-10 flex ",
    children: [tabs.map(function (currentTab, index) {
      var title = currentTab.title,
          tab = currentTab.tab;
      var isSelected = tab === selectedTab.tab;
      return /*#__PURE__*/_jsx("div", {
        "data-cy": "".concat(tab, "-tab"),
        className: classNames("text-base font-medium py-2 w-16 clickable text-center ".concat(tab, "-tab"), {
          'bg-subkit-primary text-white': isSelected,
          'text-subkit-primary bg-white': !isSelected
        }),
        onClick: function onClick() {
          return onSelectTabHandler(currentTab);
        },
        children: title
      }, index);
    }), children]
  });
};